export class AddSectionFromTemplateError extends Error {
  constructor(message = 'Failed to add section to inspection template') {
    super(message);
    this.name = 'AddSectionFromTemplateError';
  }
}
